import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Course} from '../models/course.model';
import {Store} from '@ngrx/store';
import {AppState} from '../store';
import {createNewCourse} from '../store/course.actions';
import {addCourseSection} from '../store/course-section.actions';
import {MessagesService} from '../shared/services/messages.service';
import {LoadingService} from '../shared/services/loading.service';
import {LessonsDBService} from '../services/lessons-db.service';
import {concatMap, map} from 'rxjs/operators';
import {CourseSection} from '../models/course-section.model';
import {Lesson} from '../models/lesson.model';
import {addLesson} from '../store/lesson.actions';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {AddCourseDialogSvgSpriteComponent} from './add-course-dialog-svg-sprite.component';
import {TrackingService} from '../services/tracking.service';
import {Firestore} from '@angular/fire/firestore';
import {createFirestoreId} from '../common/firestore-utils';
import { CoursesDBService } from '../services/courses-db.service';
import { ArrowLeftIconSvgComponent } from '../svg-sprites/general/arrow-left-icon-svg.component';

@Component({
  selector: 'add-course-dialog',
  templateUrl: './add-course-dialog.component.html',
  styleUrls: ['./add-course-dialog.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgIf, NgClass, NgStyle, AddCourseDialogSvgSpriteComponent ,ArrowLeftIconSvgComponent]
})
export class AddCourseDialogComponent implements OnInit {

  form: FormGroup;

  selectedItem: string = "premium";

  prevsection: boolean;
  nextsection: boolean;
  savebtn: boolean;
  backbtn: boolean;
  nextbtn: boolean;

  standardCourseDescription = "These courses are visible on your website publicly. Only paying students can watch the course, but you can still optionally mark certain lessons as free.";

  privateCourseDescription = "Ideal for a pre-defined group of students, or for an organization. Private courses are publicly visible, but they are not for sale. Students are enrolled either through a free coupon link, or manually.";

  hiddenCourseDescription = "Hidden courses are just like private courses, but they are not publicly visible. Only signed-in students that have been enrolled can see them. You can still create free coupon links for hidden courses.";

  freeCourseDescription = "Free courses are great for finding email leads that you can later convert into paying students. Students will need to provide their email in order to take the course.";

  constructor(private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddCourseDialogComponent>,
    private store: Store<AppState>,
    private firestore: Firestore,
    private messages: MessagesService,
    private loading: LoadingService,
    private lessonsDB: LessonsDBService,
    private tracking: TrackingService,
    private coursesDB: CoursesDBService) {

  }

  ngOnInit() {

    this.prevsection = true;
    this.nextsection = false;
    this.savebtn = false;
    this.backbtn = false;
    this.nextbtn = true;

    this.form = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(60)]],
      shortDescription: ['', [Validators.required, Validators.maxLength(98)]]
    });
  }

  listClick(event, newValue) {
    this.selectedItem = newValue;
  }

  close() {
    this.dialogRef.close();
  }

  next() {
    this.prevsection = false;
    this.nextsection = true;
    this.savebtn = true;
    this.backbtn = true;
    this.nextbtn = false;
  }

  back() {
    this.prevsection = true;
    this.nextsection = false;
    this.savebtn = false;
    this.backbtn = false;
    this.nextbtn = true;
  }

  async save() {

    const course = this.form.value as Course;
    course.id = createFirestoreId(this.firestore);
    course.status = 'draft';
    course.downloadAllowed = true;

    // for course type select
    if (this.selectedItem == 'privateCourseOn') {
      course.privateCourseOn = true;
    }
    else if (this.selectedItem == 'hiddenCourseOn') {
      course.hiddenCourseOn = true;
    }
    else if (this.selectedItem == 'free') {
      course.free = true;

    }

    const newMaxSeqNo = await this.coursesDB.findNextCourseSeqNo().toPromise();

    course.seqNo = newMaxSeqNo;
    course.totalLessonsPublished = 0;
    course.faqs = [];
    course.authors = [];

    // initially the course url is the courseId, it will be overwritten at publication time
    course.url = course.id;

    course.totalDuration = 0;

    this.store.dispatch(createNewCourse({ course }));

    this.tracking.reportCourseCreated();

    this.dialogRef.close();

    const createInitialCourseData$ = this.lessonsDB.addNewSection(course, "Introduction")
      .pipe(
        concatMap(section => {
          //this.router.navigate(['edit-courses', course.url, 'edit']);
          return this.lessonsDB.addNewLesson(course.id, section.id, "Introduction", "video", 1)
            .pipe(
              map(lesson => [section, lesson])
            )
        }
        )
      );

    this.loading.showLoader(createInitialCourseData$)
      .subscribe(
        ([courseSection, lesson]: [CourseSection, Lesson]) => {

          this.store.dispatch(addCourseSection({ courseSection }));

          this.store.dispatch(addLesson({ lesson }));

        },
        err => this.messages.error(err)
      );

  }


}
